import { api_url } from './env';

export default (() => {
  return api_url;
  
})()